import tw from 'twin.macro'
import React from 'react'
import { useParams } from 'react-router-dom'
import { CgAdd } from 'react-icons/cg'
import { IoIosWater } from 'react-icons/io'
import { TbVideoPlus } from 'react-icons/tb'
import { useAddRestDayMutation, useCreateWorkoutMutation, useAddVideoDayMutation } from '../programApi'
import { Button } from 'common/components/Button/Button'
import { Tooltip } from 'common/components/Tooltip/Tooltip'

export const EmptyDayCard = ({ workout, selectedWktId, alwaysShowActions = false, orgId, setEditIdx, dayIdx }) => {
  const { id: programId } = useParams()
  const [createWorkout] = useCreateWorkoutMutation()
  const [addRestDay] = useAddRestDayMutation()
  const [addVideoDay] = useAddVideoDayMutation()

  const actionContainerClassnames = alwaysShowActions
    ? `flex items-stretch flex-wrap justify-center gap-4`
    : `hidden group-hover:flex items-stretch flex-wrap justify-center gap-4`

  return (
    <EmptyHoverBlock
      onClick={() => {
        if (setEditIdx) {
          setEditIdx(null)
        }
      }}
    >
      <div className={actionContainerClassnames}>
        <Tooltip content='Add workout' triggerClasses='flex'>
          <Button
            aria-label='Add workout'
            size='md'
            variant='secondary'
            css={btnClasses}
            onClick={(e) => {
              e.stopPropagation()
              if (setEditIdx) {
                setEditIdx(dayIdx)
              }
              createWorkout({ orgId, programId, workoutId: workout.id, workout, isMultiWkt: Boolean(selectedWktId) })
            }}
          >
            <CgAdd className='w-5 h-5' />
          </Button>
        </Tooltip>
        <Tooltip content='Add rest day' triggerClasses='flex'>
          <Button
            aria-label='Add rest day'
            size='md'
            variant='secondary'
            css={btnClasses}
            onClick={(e) => {
              e.stopPropagation()
              addRestDay({ orgId, workoutId: workout.id, workout })
            }}
          >
            <IoIosWater className='w-[22px] h-[22px] text-gray-500 text-opacity-95' />
          </Button>
        </Tooltip>
        <Tooltip content='Add video' triggerClasses='flex'>
          <Button
            aria-label='Add video'
            size='md'
            variant='secondary'
            css={btnClasses}
            onClick={(e) => {
              e.stopPropagation()
              addVideoDay({ orgId, workoutId: workout.id, workout })
            }}
          >
            <TbVideoPlus className='w-[22px] h-[22px]' />
          </Button>
        </Tooltip>
      </div>
    </EmptyHoverBlock>
  )
}

const EmptyHoverBlock = tw.div`
  flex
  items-start
  justify-center
  px-4
  py-14
  h-full
`

const btnClasses = tw`
  bg-gray-100
  text-gray-600
  hover:bg-gray-100
  ring-2
  ring-gray-100
  hover:ring-tGreen
  rounded-md
  w-12
  px-3
  py-1.5
`
